import './balance';
import './block_holder';
import './candle';
import './copy_trading';
import './key_value_pair';
import './loader';
import './notify';
import './notify_telegram';
import './time';
import './total_profit';
import './total_runs';
import './webhook';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/tools/index.js